import request from '@/utils/request'

// Auth API uses different baseURL:
// - prod => https://api.galiyuejuan.com
// - other => https://debug.gali.maplebolo.com
const galiEnv = process.env.VUE_APP_GALI_ENV || (process.env.NODE_ENV === 'production' ? 'prod' : 'test')
const isDev = galiEnv !== 'prod'
const authBaseURL = isDev ? 'https://debug.gali.maplebolo.com' : 'https://api.galiyuejuan.com'

export const authApi = {
  /**
   * 获取登录 Scene (标识)
   */
  getLoginScene() {
    return request({
      url: authBaseURL + '/v1/judge/account/loginscene',
      method: 'get'
    })
  },

  /**
   * 查询登录状态
   * @param {string} scene 
   * @param {boolean} with_share_code
   */
  getLoginStatus(scene, with_share_code) {
    return request({
      url: authBaseURL + '/v1/judge/account/loginstatus',
      method: 'post',
      data: { scene, with_share_code }
    })
  },

  /**
   * 获取二维码图片地址
   * @param {string} scene 
   */
  getQrCodeUrl(scene) {
    // 参考 plugin: cocoCdn + "/v1/qr_images/" + scene + ".png"
    return `${authBaseURL}/v1/qr_images/${scene}.png`
  }
}

// 错误码常量 (参考 plugin)
export const AuthErrors = {
  ErrorMchatInvalidScene: 8000,
  ErrorMchatExpiredScene: 8001,
  ErrorMchatNotLogin: 8003
}
